import set from 'lodash/set';

const premiumSpotLightList = ['dealer-incentive', 'default', 'incentives', 'newly-listed', 'number-viewed', 'price-reduced', 'return-policy', 'sim', 'similar-listing', 'warranty'];

export const isPremiumSpotlight = (par) => premiumSpotLightList.includes(par);

export const addListingTriggerData = (par, cdl = {}) => {
    if (isPremiumSpotlight(par)) {
        const listingTrigger = (par === 'sim') ? 'similar' : par;
        set(cdl, 'vehicle.listingTrigger', listingTrigger);
    }
    return cdl;
};
